import { Tag } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  status: string;
}
const Status = (props: Props) => {
  const { t } = useTranslation();
  const { status } = props;
  switch (status) {
    case "completed":
      return <Tag color="success">{t("Completed")}</Tag>;
    case "started":
      return <Tag color="processing">{t("Started")}</Tag>;
    case "failed":
      return <Tag color="error">{t("Failed")}</Tag>;
  }
  return null;
};

export default Status;
